import {Component, Inject} from '@angular/core';
import {CustomButtonToggleOption} from '../../_types/shared';
import {DatePipe} from '@angular/common';
import {RewardsService} from '../../_services/rewards.service';
import {Community} from '../../_types/communities';
import {LocalStorageService} from '../../_services/local-storage.service';
import {LeaderboardUser} from '../../_types/rewards';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ContentService} from "../../_services/content.service";
import {ThemeService} from "../../_services/theme.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

enum TimeMode {
    AllTime,
    CurrentMonth,
    LastYear
}

@Component({
    selector: 'app-points-leaderboard',
    templateUrl: './points-leaderboard.component.html',
    styleUrl: './points-leaderboard.component.scss',
    providers: [DatePipe]
})
export class PointsLeaderboardComponent {
    users: LeaderboardUser[] = [];
    modeOptions: CustomButtonToggleOption[] = [
        {label: 'All time', value: TimeMode.AllTime},
        {label: 'Last year', value: TimeMode.LastYear},
        {label: 'This month', value: TimeMode.CurrentMonth}
    ];
    mode: any = TimeMode.CurrentMonth;
    community: Community | null = null
    isDialog: boolean = false;
    loading: boolean | null = null;
    userInfoMenuOpen: boolean = false;

    constructor(
        private readonly rewardsService: RewardsService,
        private readonly localStorageService: LocalStorageService,
        private contentService: ContentService,
        protected themeService: ThemeService,
        @Inject(MAT_DIALOG_DATA) public data: { isDialog: true }
    ) {
        if (data?.isDialog) {
            this.isDialog = true;
        }
        this.contentService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.community = community;
                if (community?.points_leaderboard_all_time_text) {
                    this.modeOptions[0].label = community.points_leaderboard_all_time_text;
                }
                if (community?.points_leaderboard_year_text) {
                    this.modeOptions[1].label = community.points_leaderboard_year_text;
                }
                if (community?.points_leaderboard_month_text) {
                    this.modeOptions[2].label = community.points_leaderboard_month_text;
                }
            });
    }

    userTrack(index: number, user: LeaderboardUser): number {
        return user.id;
    }

    listenPointsUpdateEvents(event: any): void {
        setTimeout((): void => {
            // Delay loading wheel for 3 seconds.
            if (this.loading != false) {
                this.loading = true;
            }
        }, 2000);
        let community: Community | null = this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null)
        if (!community) return;
        if (event === TimeMode.CurrentMonth.valueOf()) {
            this.rewardsService.getLeaderboardMonthly(community.id).subscribe(r => {
                this.users = r
                    .map(({
                              user: id,
                              ...rest
                          }: any) => ({
                        id,
                        ...rest
                    }));
                this.loading = false;
            }, e => {
                this.loading = false;
            })
        } else if (event === TimeMode.AllTime.valueOf()) {
            this.rewardsService.getLeaderboardForAllTime(community.id).subscribe(r => {
                this.users = r
                    .map(({
                              user: id,
                              ...rest
                          }: any) => ({
                        id,
                        ...rest
                    }));
                this.loading = false;
            }, e => {
                this.loading = false;
            })
        } else {
            this.rewardsService.getLeaderboardForLastYear(community.id).subscribe(r => {
                this.users = r
                    .map(({
                              user: id,
                              ...rest
                          }: any) => ({
                        id,
                        ...rest
                    }));
                this.loading = false;
            }, e => {
                this.loading = false;
            })
        }
    }
}
